export default "__VITE_ASSET__RndK50ZI__"